exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-expand--button{position:absolute;top:5%;right:6%;z-index:999;border-radius:50%;background:#f2f2f2;width:50px;height:50px;padding:0;box-shadow:1px 3px 5px rgba(0,0,0,.2);border:none;font-size:20px;opacity:.9}@media (max-width:768px){.image-expand--button{top:auto;bottom:5%}}", ""]);

// exports
